import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// used to create fake backend
import { fakeBackendProvider } from './_helpers';

import { AppRoutingModule } from './app-routing.module';
import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { AppComponent } from './app.component';
import { AlertComponent } from './_components';
import { HomeComponent } from './home';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxCaptchaModule } from 'ngx-captcha';
import { ConnectionModule } from './connection/connection.module';
import { NgWizardModule, NgWizardConfig, THEME } from 'ng-wizard';
import {  NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from "ngx-spinner";
import { UserValidateComponent } from './_components/user/user-validate/user-validate.component';
import { AutomationRequestComponent } from './_components/user/automation-request/automation-request.component';
import { InformationComponent } from './_components/information/information.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ForgetPasswordComponent } from './forgetpassword.component';
import { ChangePasswordComponent } from './changepassword.component';
import { ResetPasswordComponent } from './_components/resetpassword/resetpassword.component';




const ngWizardConfig: NgWizardConfig = {
  theme: THEME.default
};
@NgModule({
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    NgxPaginationModule,
    NgxCaptchaModule,
    ConnectionModule,
    NgWizardModule.forRoot(ngWizardConfig),
    NgbModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    MatDialogModule,
    FormsModule
    
    
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    AlertComponent,
    HomeComponent,
    UserValidateComponent,
    AutomationRequestComponent,
    InformationComponent,
    ForgetPasswordComponent,
    ChangePasswordComponent,
    ResetPasswordComponent
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    // provider used to create fake backend
    fakeBackendProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { };
